export default __webpack_public_path__ + "static/media/check.d361ff1f.svg";